import { staticApis } from "../client";
import { BillingSession, Subscription } from "../schemas/billing";
// These are always current account operations. asOf tags are only stale-result guards.
export const { getSubscription, createCheckout, createBillingPortal } =
	staticApis({
		getSubscription: ["GET", "/billing/subscription", Subscription],
		createCheckout: ["POST", "/billing/checkout", BillingSession, { body: {} }],
		createBillingPortal: [
			"POST",
			"/billing/portal",
			BillingSession,
			{ body: {} },
		],
	});
